// extracted by mini-css-extract-plugin
export default {"grid":"ExoticResultsField_grid__QenBY","exoticLabel":"ExoticResultsField_exoticLabel__ay+Oq","exoticTitle":"ExoticResultsField_exoticTitle__Ds2t9"};